// extracted by mini-css-extract-plugin
export var form = "_dw-0";